<div class="flex flex-col items-center text-center p-6 space-y-4">
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" rel="stylesheet">

    <div class="bg-[var(--p-primary-500)] rounded-full h-[95px] w-[95px]  flex items-center justify-center">
        <i class="fas fa-check text-white custom-thick-icon  fa-3x"></i>
    </div>

    <div>
        <h2 class=" text-2xl font-semibold mt-6 font-mulish">Thank You!</h2>
        <p class="text-lg mt-2 mb-2  font-mulish ">Your information has been received, and our team will be reaching out
            shortly with the next steps.</p>

        <p class="text-lg mt-2 mb-2  font-mulish ">Together, we’re making a difference!</p>

        <div class="w-full">
            <button pButton class="p-button-info rounded-lg w-full mt-6 flex items-center justify-center gap-2 mt-4"
                [rounded]="true" (click)="onClose()">
                <i class="fas fa-heart !text-[var(--p-text-color-secondary)] text-lg"></i>
                <span class="flex-1 text-center !text-[var(--p-text-color-secondary)] font-medium font-mulish text-base">Done</span>
            </button>
        </div>
    </div>